import { useFormStore } from "@/contexts/paymentFlowContext";
import { useRef } from "react";
import StepHeader from "./StepHeader";
import CheckoutForm from "./CheckOutForm";
import StepFooter from "./stepFooter";
import { t } from "i18next";
import { ScrollArea } from "@/components/ui/scroll-area";

const options = [
  {
    value: "Credit Card",
    label: "Credit Card",
    icon: "/icons/Mastercard.svg",
    formSchema: {
      email: true,
      fullName: true,
      phoneNumber: true,
      creditCardForm: true,
    },
  },
  {
    value: "Donate in person",
    label: "Donate in person",
    icon: "/icons/wallet.svg",
    formSchema: {
      email: true,
      fullName: true,
      phoneNumber: true,
      address: true,
      city: true,
      collection_date: false,
    },
  },
];

const DetailsStep = () => {
  const { selectedOption } = useFormStore();
  const formRef = useRef<any>(null);

  const handleNextStep = () => {
    if (formRef.current) {
      formRef.current.submitForm();
    }
  };

  const selectedOptionSchema = options.find((option) => option.value === selectedOption);
  return (
    <>
      <StepHeader />
      <ScrollArea className="my-4 flex h-screen w-full flex-grow items-center justify-center gap-16 overflow-y-auto bg-background  md:mt-16">
        <div className="flex w-full flex-col items-center justify-center px-4">
          <div className="w-full lg:max-w-[43rem]">
            <div className="mb-4 flex w-full flex-col items-start justify-start gap-4">
              <h3 className="text-xl font-bold leading-[120%] sm:text-[32px]">
                {t("donationFlow.details")}{" "}
              </h3>
            </div>
            <div className="flex w-full flex-col gap-6">
              {selectedOption === "Donate in person" && (
                <span className="text-sm font-normal leading-[150%] md:text-base">
                  {t("donationFlow.available")}
                </span>
              )}
              {(selectedOption === "Bank Installment" ||
                selectedOption === "Buy Now, Pay Later") && (
                <div className="h-96 border border-black"></div>
              )}
              <CheckoutForm
                ref={formRef}
                selectedOption={selectedOption ?? ""}
                schema={selectedOptionSchema?.formSchema ?? {}}
              />
            </div>
          </div>
        </div>
      </ScrollArea>
      <StepFooter nextStep={handleNextStep} />
    </>
  );
};

export default DetailsStep;
